import useUserSettings from "@/composables/useUserSettings";
const { getUserSetting } = useUserSettings();

export default {
    namespaced: true,
    state: {
        isVerticalMenuCollapsed: Boolean(Number(getUserSetting("rightSideMenuIsOpen"))),
        isRightMenuCollapsed: !Number(getUserSetting("rightSideMenuIsOpen")),
    },
    getters: {},
    mutations: {
        UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
            state.isVerticalMenuCollapsed = val;
            localStorage.setItem("menuIsCollapsed", val);
        },
        UPDATE_RIGHT_MENU_COLLAPSED(state, val) {
            state.isRightMenuCollapsed = val;
            localStorage.setItem("menuRightIsCollapsed", val);
        },
    },
    actions: {},
};
